(function () {
  'use strict';

  var STORAGE_KEY = 'aurova_wishlist_v1';

  /* ── Storage layer ── */
  var Wishlist = {
    getItems: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    },
    setItems: function (items) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
    },
    has: function (productId) {
      var id = String(productId);
      return this.getItems().some(function (i) { return String(i.id) === id; });
    },
    toggle: function (product) {
      var items = this.getItems();
      var id = String(product.id);
      var idx = -1;
      for (var j = 0; j < items.length; j++) {
        if (String(items[j].id) === id) { idx = j; break; }
      }
      if (idx === -1) {
        items.push(product);
        this.setItems(items);
        return true;
      } else {
        items.splice(idx, 1);
        this.setItems(items);
        return false;
      }
    },
    count: function () { return this.getItems().length; }
  };

  /* ── Header badge ── */
  function updateBadge() {
    var badge = document.getElementById('aur-wishlist-badge');
    if (!badge) return;
    var count = Wishlist.count();
    badge.textContent = count > 99 ? '99+' : String(count);
    if (count > 0) {
      badge.classList.remove('aur-hdr__cart-badge--hidden');
    } else {
      badge.classList.add('aur-hdr__cart-badge--hidden');
    }
  }

  /* ── Sync a single button's appearance ── */
  function syncBtn(btn) {
    var active = Wishlist.has(btn.dataset.productId);
    btn.classList[active ? 'add' : 'remove']('aur-wl-btn--active');
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  /* ── Sync all buttons on the page ── */
  function syncAll() {
    document.querySelectorAll('[data-aurova-wishlist-btn]').forEach(syncBtn);
    updateBadge();
  }

  /* ── Delegated click handler ── */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-aurova-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var product = {
      id:     btn.dataset.productId,
      handle: btn.dataset.productHandle,
      title:  btn.dataset.productTitle,
      price:  btn.dataset.productPrice,
      image:  btn.dataset.productImage,
      url:    btn.dataset.productUrl
    };

    Wishlist.toggle(product);
    syncBtn(btn);
    updateBadge();

    /* Heartbeat animation */
    var icon = btn.querySelector('.aur-wl-btn__icon');
    if (icon && icon.animate) {
      icon.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.5)' },
          { transform: 'scale(0.85)' },
          { transform: 'scale(1)' }
        ],
        { duration: 340, easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }
      );
    }
  });

  /* ── Wishlist page renderer ── */
  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* Format cents as currency (matches the $ formatting used elsewhere) */
  function formatMoney(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts[0] + '.' + parts[1];
  }

  /* Re-fetch each item's live price so the wishlist never shows a stale value */
  function refreshPrices(items, root) {
    items.forEach(function (item) {
      if (!item.handle) return;
      fetch('/products/' + encodeURIComponent(item.handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var el = root.querySelector('[data-wl-price="' + item.handle + '"]');
          if (el) el.textContent = formatMoney(p.price);
        })
        .catch(function () { /* keep the stored price on failure */ });
    });
  }

  function renderWishlistPage() {
    var root = document.getElementById('aur-wishlist-page');
    if (!root) return;

    var items = Wishlist.getItems();

    if (items.length === 0) {
      root.innerHTML =
        '<div class="aur-wl__empty">' +
          '<svg class="aur-wl__empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
          '</svg>' +
          '<p class="aur-wl__empty-title">Your wishlist is empty</p>' +
          '<p class="aur-wl__empty-sub">Save products you love and find them here anytime.</p>' +
          '<a href="/collections/all" class="aur-wl__browse-btn">Browse Products</a>' +
        '</div>';
      return;
    }

    var html = '<ul class="aur-wl__grid" role="list">';

    items.forEach(function (item) {
      var imgHtml = item.image
        ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" loading="lazy" class="aur-wl__card-img">'
        : '<div class="aur-wl__card-img aur-wl__card-img--empty"></div>';

      html +=
        '<li class="aur-wl__card">' +
          '<a href="' + esc(item.url) + '" class="aur-wl__card-img-wrap">' + imgHtml + '</a>' +
          '<div class="aur-wl__card-body">' +
            '<a href="' + esc(item.url) + '" class="aur-wl__card-title">' + esc(item.title) + '</a>' +
            ((item.price || item.handle) ? '<p class="aur-wl__card-price" data-wl-price="' + esc(String(item.handle || '')) + '">' + esc(item.price || '') + '</p>' : '') +
          '</div>' +
          '<div class="aur-wl__card-actions">' +
            '<a href="' + esc(item.url) + '" class="aur-wl__shop-btn">Shop Now</a>' +
            '<button class="aur-wl__remove-btn" data-wl-remove="' + esc(String(item.id)) + '" type="button" aria-label="Remove from wishlist">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
            '</button>' +
          '</div>' +
        '</li>';
    });

    html += '</ul>';
    root.innerHTML = html;

    refreshPrices(items, root);

    root.querySelectorAll('[data-wl-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.wlRemove;
        var remaining = Wishlist.getItems().filter(function (i) { return String(i.id) !== id; });
        Wishlist.setItems(remaining);
        updateBadge();
        renderWishlistPage();
      });
    });
  }

  /* ── Init ── */
  function init() {
    syncAll();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AurovaWishlist = Wishlist;
})();
